import React from 'react';
import Title from '../../../../../@casino/ui/title';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TableCasino from '../../../../../@casino/ui/table';
import {columns, getRows} from './helper';
import { useDispatch, useSelector } from 'react-redux';
import { setGetCreditHisotry } from '../../store/thunk/setGetCreditHistory';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20, 
        paddingTop: 0, 
        color: '#fff'
    },
    wrap: {
        padding: 0, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12,
    },
    search: {
        padding: 10,
        background: '#141b33',
        paddingLeft: 10,
        border: '1px solid #141b33',
        color: '#fff',
        outline: 'none',
        margin: 10,
        width: '97.3%'
    },
    wrapBlock: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12,
    }
}))

const HistoryCredit = () => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [search, setSearch] = React.useState('');

    React.useEffect(() => {
        dispatch(setGetCreditHisotry({
            page: 1,
            rowsPerPage: 10,
            search: ''
        }))
    }, []);

    const history = useSelector(state => state.creditHistory.history);
    
    const rows = React.useMemo(() => {
        return getRows(history.list)
    }, [history.list])

    return (
        <div style={{padding: '0px 20px 20px'}}>
            <Title label="История о выданных кредитах"/>
            <div className={classes.wrap}>
                <label htmlFor="search">
                    <input 
                        type="text"
                        name="search" 
                        id="search" 
                        value={search} 
                        onChange={(v) => {
                            dispatch(setGetCreditHisotry({
                                page: 1,
                                rowsPerPage: 10,
                                search: v.target.value
                            }))
                            setSearch(v.target.value)
                        }} 
                        className={classes.search}
                        placeholder="Поиск группы"
                    />
                   
                </label>
            </div>
            <div className={classes.wrapBlock}>
                <TableCasino 
                   pagination
                   allPage={history.page}
                    width={800}
                    perPage={10}
                    columns={columns}
                    rows={rows}
                    changePage={(v) => dispatch(setGetCreditHisotry({
                        page: +v.page+1,
                        rowsPerPage: v.rowsPerPage,
                        search
                    }))}
                    changeRowsPerPage={(v) => dispatch(setGetCreditHisotry({
                        page: +v.page + 1,
                        rowsPerPage: v.rowsPerPage,
                        search
                    }))}
                />            
            </div>
        </div>
    )
}

export default HistoryCredit;